import getGroupDetails from "owa-groups-shared-store/lib/selectors/getGroupDetails";
import type { MailboxInfo } from "owa-client-types";
import type RetentionPolicyTag from "owa-service/lib/contract/RetentionPolicyTag";

export default function getRetentionPolicyTagsForGroup(mailboxInfo: MailboxInfo, groupId: string | null): RetentionPolicyTag[] {
    if (!groupId) {
        return [];
    }
    
    const groupDetails = getGroupDetails(mailboxInfo, groupId);
    
    return groupDetails?.MailboxSettings?.RetentionPolicyTags ?? [];
}
